import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { DevicesState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: DevicesState = getDefaultState();

const namespaced: boolean = true;

export const devices: Module<DevicesState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
